"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.add28mul8 = void 0;
function add28mul8(x, y) {
    var carry = 0;
    var out = new Uint8Array(32);
    for (var i = 0; i < 28; i++) {
        var r = x[i] + (y[i] << 3) + carry;
        out[i] = r & 0xff;
        carry = r >> 8;
    }
    for (var i = 28; i < 32; i++) {
        var r = x[i] + carry;
        out[i] = r & 0xff;
        carry = r >> 8;
    }
    return out;
}
exports.add28mul8 = add28mul8;
